import React from 'react';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import FormFieldInlineLabel from 'components/anvilFormFillable/FormFieldInlineLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import { isEmptyString } from 'utils/helper';

export default function Checkbox({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  const checkboxId = field?.id ?? 'checkbox';

  return (
    <FormControlLabel
      control={(
        <MuiCheckbox
          id={checkboxId}
          autoFocus={error}
          checked={isEmptyString(value?.value) ? false : value?.value as boolean}
          onChange={(event) => { onChange?.({ ...value, value: event.target?.checked }); }}
        />
      )}
      label={(
        <FormFieldInlineLabel
          name={field?.name}
          isRequired={field?.isRequired}
          type={field?.type}
        />
      )}
    />
  );
}
